import HeroCarousel from "@/components/feature/HeroCarousel";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieGrid from "@/components/feature/MovieGrid";
import SearchBand from "@/pages/home/components/SearchBand";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import HotRanking from "@/pages/home/components/HotRanking";
import NewsSection from "@/pages/home/components/NewsSection";
import IntroBand from "@/pages/home/components/IntroBand";
import { banners } from "@/mocks/banners";
import type { Banner } from "@/types/media";
import { getHotMovies, getLatestMovies, getLatestNews } from "@/utils/media";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "91影视-最新电影电视剧播放与影视资讯平台",
    description:
      "91影视为您提供最新电影、电视剧资源和丰富影视资讯，覆盖多类型影视作品，满足您的观影和信息需求。",
    keywords: "91影视,影视网站,电影,电视剧,影视资讯,在线观看,影视推荐",
  });

  const latestMovies = getLatestMovies(10);
  const hotMovies = getHotMovies(8);
  const latestNews = getLatestNews(6);

  return (
    <>
      <HeroCarousel banners={banners as unknown as Banner[]} />
      <SearchBand />
      <CategoryEntries />

      <section className="mx-auto w-full max-w-[1280px] px-4 pt-10 md:px-8 md:pt-12">
        <SectionHeading
          title="最新影视推荐"
          subtitle="按更新时间为你揭晓最新上线的影视作品"
          moreTo="/category/movie"
        />
        <MovieGrid movies={latestMovies} />
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 pt-10 md:px-8 md:pt-12">
        <SectionHeading
          title="热门影视精选"
          subtitle="近期点击与收藏热度较高的影片"
          moreTo="/category/tv"
        />
        <HotRanking movies={hotMovies} />
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 pt-10 md:px-8 md:pt-12">
        <SectionHeading title="最新影视资讯" subtitle="行业动态与影评推荐" moreTo="/news" />
        <NewsSection news={latestNews} />
      </section>

      <IntroBand />
      <div className="h-4"></div>
    </>
  );
}